/* ═══════════════════════════════════════════════════════════════════
   MATRIKAR — Gift Reconciler (Brique A) — assets/mk-gift.js
   2026-06-08, reecrit le 2026-09-22 (cadeau = Wireless Car Charger, et cadeau MANUEL)

   CE QUI A CHANGE LE 2026-09-22 :

   1. LE CADEAU NE S'AJOUTE PLUS TOUT SEUL. C'est le client qui coche le bouton du
      bloc cadeau de la fiche produit ; assets/cart-unified.js pose la ligne au moment
      de l'ajout au panier. Ce module ne fait plus que le MENAGE :
        - retirer le cadeau quand il ne reste plus aucun tapis dans le panier,
        - ecraser les doublons,
        - forcer la quantite a 1,
        - retirer les vieilles lignes cadeau organisateur laissees dans un panier
          commence avant la bascule (sinon elles seraient FACTUREES 79 $).
      Il n'y a donc plus de "decline" a memoriser : rien ne re-ajoute jamais.

   2. TOUS LES TAPIS RENDENT ELIGIBLE, y compris les fiches vehicule (handle en
      '-floor-mats-') et y compris Front Only. La remise automatique du chargeur vise
      la collection "GIFT SCOPE - All Car Mats" et les 3 ensembles.

   PRICE AUTHORITY = la remise automatique Shopify (Buy: un tapis de la collection
   GIFT SCOPE -> Get: 1x Wireless Car Charger a 100 % de rabais). Ce module n'ecrit
   JAMAIS un prix. La propriete `_free_gift` sert a identifier la ligne, rien d'autre.

   Independent module. Does NOT touch image zoom (mk-image-zoom), qty UI,
   cross-sell, or checkout. Loaded globally (defer) via layout/theme.liquid.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ---- config (MUST mirror the automatic discount scope) ---- */
  var GIFT_VARIANTS = [47902932074657];                                   // Wireless Car Charger (produit cache `gift-wireless-car-charger`)
  var MARKER = 'wireless-charger';                                        // _free_gift property value

  /* ---- heritage : le cadeau d'avant le 2026-09-22 (organisateur de coffre) ----
     Un panier commence avant la bascule porte encore une ligne organisateur marquee
     `diamond-trunk-small`. Sa remise BXGY est eteinte : cette ligne serait FACTUREE
     79 $. On la retire systematiquement, quel que soit le contenu du panier. */
  var LEGACY_MARKER = 'diamond-trunk-small';
  var LEGACY_VARIANTS = [45931833098401, 45931832672417, 45931831951521];

  /* ---- P1 (2026-08-05) : émetteur du bus panier, idempotent + global (défini par le 1er module chargé) ---- */
  window.mkEmitCartChanged = window.mkEmitCartChanged || function (cart, source) {
    try { document.dispatchEvent(new CustomEvent('mk:cart:changed', { bubbles: true, detail: { cart: cart, source: source || '' } })); } catch (e) { /* noop */ }
  };

  /* ---- loop-protection + decline state ---- */
  var reconciling = false;   // GUARD 1 — mutex: a reconcile pass is in-flight
  var pendingRun = false;    //          coalesce: a change arrived while reconciling
  var debounceTimer = null;  // GUARD 3 — debounce bursts of events
  var prevHadGift = false;   // was a gift line present at the end of the LAST pass?
                             // (used to tell a USER removal apart from "never added yet")
  var pendingCart = null;    // P1 — panier fourni par l'événement `mk:cart:changed` (évite un GET)

  /* ---- cart helpers ---- */
  function getCart() {
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  // 2026-09-08 : product_type est TRADUIT par Translate & Adapt ("Tapis d'auto" sur /fr),
  // donc un test sur product_type rendait TOUT panier francais ineligible. Le `handle`, lui,
  // n'est PAS traduit (verifie le 2026-09-08 sur /fr/cart.js) -> on raisonne dessus, par
  // exclusion, comme le fait deja snippets/mk-is-car-mat.liquid cote Liquid.
  // 2026-09-22 : 'floor-mats' AJOUTE. Les 9 686 fiches vehicule portent ce handle et elles
  // font desormais partie de la promo. Les exclusions ci-dessous ecartent toujours les
  // housses, tapis de coffre, organisateurs et hamacs.
  // 2026-09-22 : le test de couverture est SUPPRIME. Front Only donne droit au cadeau lui aussi.
  var MAT_RE     = /car-mats|floor-mats/;
  var NOT_MAT_RE = /trunk-mat|seat-cover|organizer|hammock|backseat|petshield/;
  function isEligibleCarMat(item) {
    var h = (item.handle || '').toLowerCase();
    return MAT_RE.test(h) && !NOT_MAT_RE.test(h);
  }
  function isGiftLine(item) {
    var p = item.properties || {};
    return p._free_gift === MARKER || (GIFT_VARIANTS.indexOf(item.id) !== -1 && !!p._free_gift);
  }
  // Ligne cadeau de l'ANCIENNE promo (organisateur), a retirer sans condition.
  function isLegacyGiftLine(item) {
    var p = item.properties || {};
    return p._free_gift === LEGACY_MARKER || (LEGACY_VARIANTS.indexOf(item.id) !== -1 && !!p._free_gift);
  }
  // 2026-09-22 : la fonction addGift() a ete SUPPRIMEE. Le cadeau ne s'ajoute plus tout seul,
  // c'est le client qui le demande depuis la fiche produit et cart-unified.js qui pose la ligne.
  // P1 (2026-08-05) — retrait / qty du cadeau via /cart/change.js PAR CLÉ (rule B ; JAMAIS update.js
  // ici). change.js ne touche QUE la ligne ciblée → les properties des AUTRES lignes (props véhicule
  // du tapis, etc.) restent intactes. Batch séquentiel (1 clé = 1 change.js ; retrait simple = 1 appel).
  function updateLines(updates) {
    var keys = Object.keys(updates);
    return keys.reduce(function (p, k) {
      return p.then(function () {
        return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: k, quantity: updates[k] })
        });
      });
    }, Promise.resolve()).then(function (r) {
      // MICRO-OPT P1 : change.js renvoie DÉJÀ le panier complet → on le rend au reconciler
      // pour ré-émettre le bus SANS getCart() séparé (−1 requête).
      return (r && typeof r.json === 'function') ? r.json() : null;
    });
  }
  function zeroMap(lines) { var m = {}; lines.forEach(function (l) { m[l.key] = 0; }); return m; }

  /* ---- the reconciler ---- */
  // P1 (2026-08-05) — pilotée par le bus `mk:cart:changed`. Si l'événement fournit le panier
  // (pendingCart), on l'utilise → ZÉRO GET. Après une VRAIE mutation cadeau (add/remove/qty), on
  // refetch UNE fois le panier définitif et on ré-émet `mk:cart:changed` source:'gift' pour que le
  // drawer affiche la ligne cadeau. LOOP-SAFE : notre listener IGNORE source:'gift' → aucun self-trigger.
  function reconcile() {
    if (reconciling) { pendingRun = true; return; }   // GUARD 1 — never two passes at once
    reconciling = true;
    var srcCart = pendingCart; pendingCart = null;     // consomme le panier de l'événement (si présent)
    var didMutate = false;
    var getCartP = (srcCart && srcCart.items) ? Promise.resolve(srcCart) : getCart();
    return getCartP.then(function (cart) {
      var items = (cart && cart.items) || [];
      var eligible = items.some(isEligibleCarMat);
      var gifts = items.filter(isGiftLine);
      var legacy = items.filter(isLegacyGiftLine);

      // GUARD 2 — idempotency: each branch makes its own trigger condition false afterwards.

      // (0) 2026-09-22 — ligne cadeau de l'ANCIENNE promo (organisateur) laissee dans un panier
      //     commence avant la bascule. Sa remise est eteinte : on la retire TOUJOURS, sinon le
      //     client paie 79 $ pour un article qu'on lui avait annonce gratuit.
      if (legacy.length > 0) {
        didMutate = true;
        return updateLines(zeroMap(legacy));
      }
      // (1) plus aucun tapis dans le panier -> on retire le cadeau. Retrait SYSTEME.
      if (!eligible && gifts.length > 0) {
        prevHadGift = false; didMutate = true;
        return updateLines(zeroMap(gifts));
      }
      // (2) safety: collapse duplicate gifts to a single line.
      if (gifts.length > 1) {
        prevHadGift = true; didMutate = true;
        return updateLines(zeroMap(gifts.slice(1)));
      }
      // (3) eligible + gift present -> just enforce qty 1.
      if (eligible && gifts.length === 1) {
        prevHadGift = true;
        if (gifts[0].quantity !== 1) { didMutate = true; var q = {}; q[gifts[0].key] = 1; return updateLines(q); }
        return null;
      }
      // (4) 2026-09-22 — tapis present mais PAS de cadeau : on ne fait RIEN. Le cadeau est
      //     manuel, il ne se pose que si le client l'a demande sur la fiche produit. Un client
      //     qui retire son cadeau du panier ne le voit donc jamais revenir.
      prevHadGift = false;
      return null;
    }).catch(function () {
      /* swallow — never block the cart */ return null;
    }).then(function (mutationCart) {                                // mutationCart = panier renvoyé par change.js (ou null)
      reconciling = false;
      if (didMutate) {
        if (mutationCart && mutationCart.items) {                    // MICRO-OPT : réutilise le panier de change.js (0 getCart)
          window.currentCart = mutationCart;
          if (window.mkEmitCartChanged) window.mkEmitCartChanged(mutationCart, 'gift');
        } else {                                                     // filet : mutation sans panier renvoyé → 1 refetch
          getCart().then(function (c) { window.currentCart = c; if (window.mkEmitCartChanged) window.mkEmitCartChanged(c, 'gift'); }).catch(function () {});
        }
      }
      if (pendingRun) { pendingRun = false; schedule(); }            // run once more for a coalesced change
    });
  }

  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reconcile, 20);                       // GUARD 3 — debounce court (120→20ms) : le cadeau part quasi immédiatement après l'add ; le mutex `reconciling` empêche les double-passes
  }

  /* ---- trigger : BUS PANIER UNIFIÉ (P1 2026-08-05) — remplace le patch window.fetch ---- */
  // Plus aucun patch de window.fetch. On écoute `mk:cart:changed` (émis par cart-unified.js après
  // l'ajout, et par le drawer après qty/suppression), en réutilisant le panier joint (zéro GET).
  // LOOP-SAFE : on IGNORE notre propre ré-émission source:'gift' → jamais de self-trigger ni tempête.
  document.addEventListener('mk:cart:changed', function (e) {
    var d = e && e.detail;
    if (d && d.source === 'gift') return;   // GUARD LOOP : ne pas réagir à NOTRE émission post-mutation cadeau
    if (d && d.cart) pendingCart = d.cart;  // réutilise le panier de l'événement (évite un GET /cart.js)
    schedule();
  });

  /* ═══════════════════════════════════════════════════════════════════
     GIFT LINE LABEL — "INCLUDED" badge on the gift row (display only).
     ONE shared module decorates the gift row of BOTH surfaces:
       • drawer    : .cart-item[data-key]            (rebuilt by cart-drawer.js)
       • cart page : .cart-page-item[data-line-key]  (server-rendered)
     The gift row is matched by line key === the gift line's key in /cart.js.
     NO colour selector — the gift stays All Black (added by the reconciler).
     Idempotent ; a MutationObserver re-applies it after every re-render.
     ═══════════════════════════════════════════════════════════════════ */

  var STYLE_ID = 'mk-gift-ui-style';
  function injectStyleOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.mk-gift-badge{display:inline-flex;align-items:center;gap:4px;background:var(--mk-red,#D71A23);color:#fff;font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:3px 8px;border-radius:var(--mk-radius-md,6px);white-space:nowrap;margin:2px 0 8px;font-family:var(--mk-font,"Urbanist",sans-serif)}' +
      /* Sous-texte du badge INCLUDED (cadeau offert uniquement) — discret, rouge Matrikar */
      '.mk-gift-reserved{display:block;font-size:11px;font-weight:600;color:var(--mk-red,#D71A23);line-height:1.3;margin:3px 0 8px;font-family:var(--mk-font,"Urbanist",sans-serif)}';
    document.head.appendChild(s);
  }

  function buildGiftBadge() {
    injectStyleOnce();
    var badge = document.createElement('span');
    badge.className = 'mk-gift-badge';
    badge.setAttribute('data-mk-gift-ui', '1');
    badge.textContent = (window.MK_I18N && window.MK_I18N.gift_included) || '🎁 INCLUDED';
    return badge;
  }

  // Sous-texte affiché SOUS le badge INCLUDED, uniquement sur la vraie ligne cadeau.
  function buildReservedLine() {
    var line = document.createElement('div');
    line.className = 'mk-gift-reserved';
    line.setAttribute('data-mk-gift-ui', '1');
    line.textContent = (window.MK_I18N && window.MK_I18N.gift_reserved) || 'Your free charger is reserved';
    return line;
  }

  /* 2026-09-22 : le squelette "le cadeau arrive" a ete SUPPRIME. Il annoncait un cadeau que
     le reconciler etait en train de poser tout seul. Le cadeau etant desormais manuel, ce
     squelette serait reste affiche en permanence pour tout client qui ne le veut pas. */

  function applyDecorate(cart) {
    var items = (cart && cart.items) || [];
    var gifts = items.filter(isGiftLine);
    var gift = gifts.length ? gifts[0] : null;
    var rows = document.querySelectorAll('.cart-item[data-key], .cart-page-item[data-line-key]');
    Array.prototype.forEach.call(rows, function (row) {
      var key = row.getAttribute('data-key') || row.getAttribute('data-line-key');
      var existing = row.querySelector('.mk-gift-badge');
      if (gift && key === gift.key) {
        if (existing) return;                               // already labelled
        var badge = buildGiftBadge();
        var info = row.querySelector('.cart-item-info') || row.querySelector('.cart-page-info') || row;
        var name = info.querySelector('.cart-item-name') || info.querySelector('.cart-page-name');
        if (name && name.nextSibling) info.insertBefore(badge, name.nextSibling);
        else if (name) info.appendChild(badge);
        else info.insertBefore(badge, info.firstChild);
        // Ligne "Your free charger is reserved" juste sous le badge INCLUDED (cadeau offert only)
        var reserved = buildReservedLine();
        if (badge.nextSibling) info.insertBefore(reserved, badge.nextSibling);
        else info.appendChild(reserved);
      } else if (existing) {
        existing.parentNode.removeChild(existing);          // stale (row no longer the gift)
        var staleReserved = row.querySelector('.mk-gift-reserved');
        if (staleReserved && staleReserved.parentNode) staleReserved.parentNode.removeChild(staleReserved);
      }
    });

    // 2026-09-22 : plus de squelette d'attente ici, le cadeau ne s'ajoute plus tout seul.
  }

  var decorateTimer = null;
  function scheduleDecorate() {
    clearTimeout(decorateTimer);
    decorateTimer = setTimeout(function () {
      if (window.currentCart) applyDecorate(window.currentCart);
      else getCart().then(applyDecorate).catch(function () {});
    }, 60);
  }

  function observeSurface(el) {
    if (!el || typeof MutationObserver === 'undefined') return;
    new MutationObserver(scheduleDecorate).observe(el, { childList: true, subtree: true });
  }
  function initGiftUI() {
    observeSurface(document.getElementById('mkCartItems'));       // drawer line-items container
    observeSurface(document.querySelector('.cart-page-items'));   // full cart page line-items container
    ['cart:change', 'cart:updated', 'variant:add'].forEach(function (ev) {
      document.addEventListener(ev, scheduleDecorate);
    });
    scheduleDecorate();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftUI);
  } else {
    initGiftUI();
  }

  // (c) initial load — an eligible Diamond may already be in the cart.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
